import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import Translation from '@swf/components/Translation/Translation';
import { UserClubRole } from '@swf/core/types/Poker';
import {
  ClubMemberAvatars,
  Image,
  Loader,
  PKR_ROLE_TRANSLATIONS,
  useCheckUserClubRole,
  useGetCurrentClub,
  useHomeGamesWidget
} from '@swf/poker';

import CreateGameButtons from './CreateGameButtons/CreateGameButtons';
import styles from './Header.scss';
import SettingsButton from './SettingsButton/SettingsButton';
import ShareButton from './ShareButton/ShareButton';

const Header: React.FC = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const club = useGetCurrentClub(clubId);

  const roleForUser = club?.roleForUser;
  const clubName = club?.clubName;
  const clubImage = club?.clubImage;
  const { widgetSelect } = useHomeGamesWidget();
  const isMember = useCheckUserClubRole(clubId, [UserClubRole.Member]);
  const enableCreate = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Manager]);
  const { clubNavHidden } = useSelector(widgetSelect.uiLayout);
  const enableMembers = enableCreate || isMember;

  return (
    <div
      className={classNames(styles.container, {
        [styles.hidden]: clubNavHidden
      })}
    >
      <Loader loading={!club}>
        <div className={styles.innerContainer}>
          <div className={styles.avatarNameContainer}>
            <div className={styles.avatar}>
              <Image imageByteArray={clubImage} />
            </div>
            <div className={styles.nameContainer}>
              <div className={styles.name}>{clubName}</div>
              <Translation tagName="span" {...PKR_ROLE_TRANSLATIONS?.[roleForUser ?? '']} />
            </div>
          </div>
          <div className={styles.actions}>
            {enableMembers && (
              <ClubMemberAvatars
                avatarClassName={styles.memberAvatar}
                clubId={Number(clubId)}
                className={styles.avatars}
              />
            )}
            {enableCreate && (
              <>
                <ShareButton />
                <CreateGameButtons />
              </>
            )}
          </div>
          <SettingsButton />
        </div>
      </Loader>
    </div>
  );
};

export default Header;
